import MainHeader from "../../../layouts/MainHeader";
import highlightPageDataAr from "../../../data/arabic/subpages/highelight-page-data-ar";
import BorderLeftCardTwo from "../../../components/cards/BorderLeftCardTwo";
import Footer from "../../../layouts/Footer";
import Separator from "../../../components/Separator";
import BorderLeftCard from "../../../components/cards/BorderLeftCard";
import ColTwo from "../../../components/FlexView/ColTwo";
import TitleGrayBg from "../../../components/Text/TitleGrayBg";
import SocialIcon from '../../../assets/icons/highlights-icons/social.svg';

const HighlightPageAr = () => {
  return (
    <main className="page" id="main">
      <div className="sticky-view-two">
        <div className="sticky-container">
          <MainHeader
            image={{
              src: require("../../../assets/images/wallpaper/highlight.jpg"),
              alt: highlightPageDataAr.header.image.alt,
            }}
            title={""}
          />
        </div>
        <div className="sticky-container-two">
          <div className="wrapper-small">
            <h1 className="title-center">{highlightPageDataAr.header.title}</h1>
            <p className="text-paraghraph">
              {highlightPageDataAr.header.subtitle}
            </p>
            <div className="margin-box"></div>
            <section>
              <TitleGrayBg
                text={highlightPageDataAr.sectionOne.title.text}
                icon={{
                  src: require(`../../../assets/icons/highlights-icons/${highlightPageDataAr.sectionOne.title.icon}`),
                  alt: "",
                }}
              />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionOne.subsectionOne.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionOne.subsectionOne.subtitle}
              </p>
              <BorderLeftCardTwo
                titleOne={
                  highlightPageDataAr.sectionOne.subsectionOne.label.titleOne
                }
                subtitleOne={
                  highlightPageDataAr.sectionOne.subsectionOne.label.subtitleOne
                }
                titleTwo={
                  highlightPageDataAr.sectionOne.subsectionOne.label.titleTwo
                }
                subtitleTwo={
                  highlightPageDataAr.sectionOne.subsectionOne.label.subtitleTwo
                }
              />
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionOne.subsectionTwo.titleOne}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionOne.subsectionTwo.subtitleOne}
              </p>
              <div className="space-25"></div>
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionOne.subsectionThree.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionOne.subsectionThree.subtitle}
              </p>
            </section>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <section>
              <TitleGrayBg
                text={highlightPageDataAr.sectionTwo.title.text}
                icon={{
                  src: require(`../../../assets/icons/highlights-icons/${highlightPageDataAr.sectionTwo.title.icon}`),
                  alt: "",
                }}
              />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionTwo.subsectionOne.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionTwo.subsectionOne.subtitle}
              </p>
              <BorderLeftCardTwo
                subtitleOne={
                  highlightPageDataAr.sectionTwo.subsectionOne.label.subtitle
                }
                titleOne={
                  highlightPageDataAr.sectionTwo.subsectionOne.label.title
                }
              />
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionTwo.subsectionTwo.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionTwo.subsectionTwo.subtitle}
              </p>
              <div className="flex-view-two">
                {highlightPageDataAr.sectionTwo.subsectionTwo.gridOne.map(
                  (item, index) => (
                    <ColTwo key={index}>
                      <BorderLeftCard
                        titleTwo={item.title}
                        subtitle={item.subtitle}
                        subtitleTwo={item.subtitleTwo}
                      />
                    </ColTwo>
                  )
                )}
              </div>
              <div className="flex-view-two">
                {highlightPageDataAr.sectionTwo.subsectionTwo.gridTwo.map(
                  (item, index) => (
                    <ColTwo key={index}>
                      <BorderLeftCard
                        titleTwo={item.title}
                        subtitle={item.subtitle}
                        subtitleTwo={item.subtitleTwo}
                      />
                    </ColTwo>
                  )
                )}
              </div>
              <Separator />
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionTwo.subsectionThree.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionTwo.subsectionThree.subtitle}
              </p>
              <div className="flex-view-two">
                {highlightPageDataAr.sectionTwo.subsectionThree.gridOne.map(
                  (item, index) => (
                    <ColTwo key={index}>
                      <BorderLeftCard
                        title={item.title}
                        subtitle={item.subtitle}
                      />
                    </ColTwo>
                  )
                )}
              </div>
              <div className="flex-view-two">
                {highlightPageDataAr.sectionTwo.subsectionThree.gridTwo.map(
                  (item, index) => (
                    <ColTwo key={index}>
                      <BorderLeftCard
                        title={item.title}
                        subtitle={item.subtitle}
                      />
                    </ColTwo>
                  )
                )}
              </div>
              <Separator />
              <p className="text-paragraph">
                {highlightPageDataAr.sectionTwo.note}
              </p>
              <div className="space-50"></div>
            </section>
            <section>
              <TitleGrayBg
                text={highlightPageDataAr.sectionThree.title.text}
                icon={{
                  src: SocialIcon,
                  alt: "",
                }}
              />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionThree.subsectionOne.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionThree.subsectionOne.subtitle}
              </p>
              <BorderLeftCardTwo
                titleOne={
                  highlightPageDataAr.sectionThree.subsectionOne.label.title
                }
                subtitleOne={
                  highlightPageDataAr.sectionThree.subsectionOne.label.subtitleOne
                }
                subtitleTwo={
                  highlightPageDataAr.sectionThree.subsectionOne.label.subtitleTwo
                }
              />
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionThree.subsectionTwo.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionThree.subsectionTwo.subtitle}
              </p>
              <BorderLeftCardTwo
                titleOne={
                  highlightPageDataAr.sectionThree.subsectionTwo.label.title
                }
                subtitleOne={
                  highlightPageDataAr.sectionThree.subsectionTwo.label.subtitleOne
                }
                subtitleTwo={
                  highlightPageDataAr.sectionThree.subsectionTwo.label.subtitleTwo
                }
              />
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionThree.subsectionThree.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionThree.subsectionThree.subtitle}
              </p>
              <div className="flex-view-two">
                {highlightPageDataAr.sectionThree.subsectionThree.gridOne.map(
                  (item, index) => (
                    <ColTwo key={index}>
                      <BorderLeftCard
                        title={item.title}
                        subtitle={item.subtitle}
                      />
                    </ColTwo>
                  )
                )}
              </div>
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionThree.subsectionFour.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionThree.subsectionFour.subtitle}
              </p>
              <BorderLeftCardTwo
                titleOne={
                  highlightPageDataAr.sectionThree.subsectionFour.label.title
                }
                subtitleTwo={
                  highlightPageDataAr.sectionThree.subsectionFour.label.subtitle
                }
              />
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionThree.subsectionFive.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionThree.subsectionFive.subtitle}
              </p>
              <BorderLeftCardTwo
                titleOne={
                  highlightPageDataAr.sectionThree.subsectionFive.label.title
                }
                subtitleTwo={
                  highlightPageDataAr.sectionThree.subsectionFive.label
                    .subtitleTwo
                }
                subtitleOne={
                  highlightPageDataAr.sectionThree.subsectionFive.label
                    .subtitleOne
                }
              />
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionThree.subsectionSix.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionThree.subsectionSix.subtitle}
              </p>
              <div className="flex-view-two-2">
                {highlightPageDataAr.sectionThree.subsectionSix.gridOne.map(
                  (item, index) => (
                    <ColTwo key={index}>
                      <BorderLeftCardTwo
                        titleOne={item.title}
                        subtitleOne={item.subtitleOne}
                        subtitleTwo={item.subtitleTwo}
                      />
                    </ColTwo>
                  )
                )}
              </div>
            </section>
            <section>
              <TitleGrayBg
                text={highlightPageDataAr.sectionFour.title.text}
                icon={{
                  src: require(`../../../assets/icons/highlights-icons/${highlightPageDataAr.sectionFour.title.icon}`),
                  alt: "",
                }}
              />{" "}
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionFour.subsectionOne.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionFour.subsectionOne.subtitle}
              </p>
              <div className="space-25"></div>
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionFour.subsectionTwo.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionFour.subsectionTwo.subtitle}
              </p>
              <div className="space-25"></div>
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionFour.subsectionThree.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionFour.subsectionThree.subtitle}
              </p>
              <div className="space-25"></div>
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionFour.subsectionFour.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionFour.subsectionFour.subtitle}
              </p>
              <div className="space-25"></div>
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionFour.subsectionFive.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionFour.subsectionFive.subtitle}
              </p>
              <div className="space-25"></div>
              <Separator />
              <div className="space-25"></div>
              <h3 className="text-title-two red-text">
                {highlightPageDataAr.sectionFour.subsectionSix.title}
              </h3>
              <p className="text-paragraph">
                {highlightPageDataAr.sectionFour.subsectionSix.subtitle}
              </p>
              <div className="space-25"></div>
              <Separator />
              <div className="space-50"></div>
              <div className="space-50"></div>
              <div className="space-50"></div>
            </section>
          </div>
          <Footer withBlogs={false} />
        </div>
      </div>
    </main>
  );
};

export default HighlightPageAr;
